/**
 * 画面表示モード
 */
export const DisplayMode = {
  // 登録
  create: 'create',
  // 参照
  read: 'read',
  // 更新
  update: 'update',
  // 削除
  delete: 'delete',
  // 承認
  approve: 'approve',
} as const;

